import React, { useEffect, useRef } from 'react'
import { fabric } from 'fabric'

const CanvasEditor = ({classList, backgroundImage, onReady}) => {

  
  const canvasEl = useRef(null)
  const canvasElParent = useRef(null)

  useEffect(()=> {
    const canvas = new fabric.Canvas(canvasEl.current)

    let canvasWidth = 0
    let canvasHeight = 0

    let aspectRatio = 0;
    let canvasWrapperWidth = canvasElParent.current.clientWidth;

    if (backgroundImage) {

      const img = new Image();
      img.setAttribute('crossOrigin', 'anonymous');
      img.onload = () => {
        const canvasImg = document.createElement("canvas");
        canvasImg.width = img.width;
        canvasImg.height = img.height;
        const ctx = canvasImg.getContext("2d");
        ctx.drawImage(img, 0, 0);
        const dataURL = canvasImg.toDataURL("image/png");

        fabric.Image.fromURL(dataURL, (imgs) => {
          let width = imgs.width;
          let height = imgs.height;
  
          aspectRatio = height / width;
          canvasWidth = canvasWrapperWidth;
          canvasHeight = canvasWrapperWidth * aspectRatio;
          
          let scaleFactor = canvasWidth / width;
          
          imgs.set({
            width: width, 
            height: height, 
            originX: 'left', 
            originY: 'top',
            scaleX: scaleFactor,
            scaleY:scaleFactor,
            crossOrigin: 'anonymous'
          });
  
          canvas.setWidth(canvasWidth);
          canvas.setHeight(canvasHeight);
          canvas.setBackgroundImage(imgs, canvas.renderAll.bind(canvas))
  
        })
        
      }
      // img.src = 'https://cdn.pixabay.com/photo/2022/07/30/16/39/roe-deer-7354145_960_720.jpg';
      img.src = backgroundImage;
     

      if (onReady) {
        onReady(canvas)
      }
      
    }

    return () => {
      canvas.dispose()
    }
  }, [backgroundImage])

  
  
  return (
    <>
      <div id="ref" ref={canvasElParent} className={classList} crossOrigin="anonymous">
        <canvas ref={canvasEl} />
      </div>
    </>
  )
}

export default CanvasEditor